import React from 'react';
import { DefaultButton, Separator, Spinner, SpinnerSize } from '@fluentui/react';
import { PrimaryButton } from 'office-ui-fabric-react';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as CircledWarning } from '@/icons/circled-warning.svg';
import * as L from '../Styles/FundDetailStyles';
import * as S from '../Styles/FundDetailsUnavailableFallbackStyles';
import { FundWithExtraDataType } from '@/services/FundService';

export interface FundDetailsUnavailableFallbackProps
{
    fund: FundWithExtraDataType,
    loadingFund: boolean,
    sending: boolean,
    subscribed: boolean,
    cancelled: boolean,
    isActiveManagementPlan: boolean,
    activeSavingsPlanHasOutdatedcontract: boolean,
    publicVersion: boolean,
    onAddToCart: () => void
}

export const FundDetailsUnavailableFallback = (props: FundDetailsUnavailableFallbackProps) =>
{
    const history = useHistory();
    const canPurchase = props.subscribed === true
        && props.isActiveManagementPlan === false
        && !props.loadingFund && props.fund?.available && !props.activeSavingsPlanHasOutdatedcontract;

    return(
        <S.Container>
            <S.IconWrapper>
                <CircledWarning />
            </S.IconWrapper>
            <S.Content>
                <S.Title>No se ha podido recuperar la información del fondo o no hay histórico de datos disponible</S.Title>
                <S.Message>
                    Puedes consultar otras clases del mismo fondo o realizar operaciones sobre el producto seleccionado.
                </S.Message>
                {props.publicVersion &&
                (
                    <React.Fragment>
                        {props.subscribed === true && props.cancelled === true &&
                        (
                            <L.RedBox>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl2 ms-xxl2 ms-xxxl2">
                                        <CircledWarning />
                                    </div>
                                    <div className="ms-Grid-col ms-sm9 ms-md9 ms-lg9 ms-xl10 ms-xxl10 ms-xxxl10" style={{ marginTop: "0.2em", fontSize: "24px" }}>
                                        <strong>Su plan está cancelado.</strong>
                                    </div>
                                </div>
                                <p>Para realizar compras o traspasos sobre cualquier tipo de inversión, tienes que volver a suscribirte en nuestra plataforma.</p>
                                {(props.publicVersion &&
                                    <Link to={"/savingsPlans/advanced"} target="_blank">
                                        <DefaultButton styles={{root: {background: '#CC214F'}}}>
                                            Suscríbete
                                        </DefaultButton>
                                    </Link>
                                ) ||
                                (
                                    <Link to={"/savingsPlans/advanced"} target="_blank">
                                        <DefaultButton styles={{root: {background: '#CC214F'}}}>
                                            Comienza a invertir
                                        </DefaultButton>
                                    </Link>
                                )}
                            </L.RedBox>
                        )}
                        {canPurchase &&
                        (
                            <S.FallbackActionsContainer>
                                <PrimaryButton className="rounded" disabled={props.loadingFund || !props.fund?.isin}
                                    onClick={() =>
                                    {
                                        history.push("/internal-switch",
                                        {
                                            target: props.fund
                                        });
                                    }}
                                >
                                    Traspasar a este producto
                                </PrimaryButton>
                                <PrimaryButton className="rounded" onClick={props.onAddToCart}
                                    disabled={props.loadingFund || !props.fund.available || props.sending}
                                >
                                    {props.sending && <Spinner size={SpinnerSize.small} className="button-spinner" />}
                                    Añadir a tu cesta
                                </PrimaryButton>
                            </S.FallbackActionsContainer>
                        )}
                        {props.subscribed === true && props.isActiveManagementPlan === true && !props.loadingFund && props.fund?.available &&
                        (
                            <L.Advise>
                                <Separator />
                                <CircledWarning />
                                <h3>COMPRA ESTE FONDO AQUÍ</h3>
                                <p>
                                    Tu plan activo seleccionado es un plan gestionado. No se permite la compra de fondos en un plan gestionado. Si deseas comprar fondos y gestionar tú
                                    mismo tu propia cartera, adquiere uno de los siguientes planes:
                                </p>
                                <L.RedBox>
                                    <div className="row">
                                        <div className="ms-Grid-col ms-sm6 ms-md-6 ms-lg-6 ms-xl-6" style={{textAlign: "center"}}>
                                            <Link to={"/savingsPlans/advanced"} target="_blank">
                                                <DefaultButton styles={{root: {background: '#CC214F'}}}>
                                                    Plan Libertad
                                                </DefaultButton>
                                            </Link>
                                        </div>
                                        <div className="ms-Grid-col ms-sm6 ms-md-6 ms-lg-6 ms-xl-6" style={{padding: 0, margin: 0, textAlign: "center"}}>
                                            <DefaultButton styles={{root: {background: '#CC214F'}}}>
                                                Gurú Financiero
                                            </DefaultButton>
                                        </div>
                                    </div>
                                </L.RedBox>
                            </L.Advise>
                        )}
                        {!props.loadingFund && !props.fund?.available &&
                        (
                            <L.Advise>
                                <Separator />
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm3 ms-md3 ms-lg3 ms-xl2 ms-xxl2 ms-xxxl2">
                                        <CircledWarning />
                                    </div>
                                    <div className="ms-Grid-col ms-sm9 ms-md9 ms-lg9 ms-xl10 ms-xxl10 ms-xxxl10" style={{marginTop: "1.1em"}}>
                                        <h3 style={{ marginLeft: "0 !important" }}>NO DISPONIBLE</h3>
                                    </div>
                                </div>
                                <p>Si desea activarlo póngase en contacto con nosotros en el mail <a href="mailto:info@ironia.tech" target="_blank" rel="noreferrer">info@ironia.tech</a></p>
                            </L.Advise>
                        )}
                        {props.subscribed === false &&
                        (
                            <L.RedBox>
                                <CircledWarning />
                                <strong>¿Quieres invertir?</strong>
                                <p>Para realizar compras o traspasos sobre cualquier tipo de inversión, tienes que tener un plan de cartera activo.</p>
                                {(props.publicVersion &&
                                    <Link to={"/savingsPlans/new"} target="_blank" style={{display: "flex", justifyContent: "flex-end", marginTop: "6px"}}>
                                        <PrimaryButton styles={{root: {background: '#CC214F', width: "48%", height: "75%", borderRadius: "20px"}}}>
                                            Nuevo Plan de Cartera
                                        </PrimaryButton>
                                    </Link>
                                ) ||
                                (
                                    <Link to={"/savingsPlans/advanced"} target="_blank" style={{display: "flex", justifyContent: "flex-end", marginTop: "6px"}}>
                                        <PrimaryButton styles={{root: {background: '#CC214F'}}}>
                                            Comienza a invertir
                                        </PrimaryButton>
                                    </Link>
                                )}
                            </L.RedBox>
                        )}
                    </React.Fragment>
                )}
            </S.Content>
        </S.Container>
    );
};